import MenuLink from "blocks/models/menu-link.interface";
import { Action } from "redux";

export const OPEN_MOBILE_MENU = "OPEN_MOBILE_MENU";
export const OPEN_FACETS_MENU = "OPEN_FACETS_MENU";
export const OPEN_MEGA_DROPDOWN_MENU = "OPEN_MEGA_DROPDOWN_MENU";
export const OPEN_PRODUCTS_MENU = "OPEN_PRODUCTS_MENU";
export const OPEN_COUNTRIES_MENU = "OPEN_COUNTRIES_MENU";
export const OPEN_MEDIA_CLOUD_DOWNLOAD_OVERLAY = "OPEN_MEDIA_CLOUD_DOWNLOAD_OVERLAY";
export const OPEN_MEDIA_CLOUD_EMAIL_OVERLAY = "OPEN_MEDIA_CLOUD_EMAIL_OVERLAY";
export const CLOSE_ALL_OVERLAYS = "CLOSE_ALL_OVERLAYS";

export interface CloseAllOverlaysAction extends Action {
    type: typeof CLOSE_ALL_OVERLAYS;
}

export interface OpenMobileMenuAction extends Action {
    type: typeof OPEN_MOBILE_MENU;
    content?: any;
}

export interface OpenFacetsMenuAction extends Action {
    type: typeof OPEN_FACETS_MENU;
}

export interface OpenMegaDropdownMenuAction extends Action {
    type: typeof OPEN_MEGA_DROPDOWN_MENU;
    content?: MenuLink;
}

export interface OpenProductsMenuAction extends Action {
    type: typeof OPEN_PRODUCTS_MENU;
}

export interface OpenCountriesMenuAction extends Action {
    type: typeof OPEN_COUNTRIES_MENU;
}

export interface OpenMediaCloudDownloadOverlayAction extends Action {
    type: typeof OPEN_MEDIA_CLOUD_DOWNLOAD_OVERLAY;
    content?: any;
}

export interface OpenMediaCloudEmailOverlayAction extends Action {
    type: typeof OPEN_MEDIA_CLOUD_EMAIL_OVERLAY;
    content?: any;
}

export type OverlayAction = CloseAllOverlaysAction | OpenMobileMenuAction | OpenMegaDropdownMenuAction | OpenProductsMenuAction | OpenCountriesMenuAction | OpenFacetsMenuAction | OpenMediaCloudDownloadOverlayAction | OpenMediaCloudEmailOverlayAction;
